define(
    'viewmodels/secured/explorer/details/tabs/actions/MoveDocumentsAction',[
        "viewmodels/secured/explorer/context",
        "viewmodels/secured/explorer/details/tabs/actions/Action",
        "viewmodels/secured/explorer/details/documentClipboard",
        "services/service.dialog",
        "services/service.documents",
        "i19n!i19n/strings"
    ],
    function (ctx, Action, documentClipboard, dialogService, documentsService, i19n) {

        var MoveDocumentsAction = (function (_super) {

            var _i19n = {
                action: {
                    name: i19n.to.movedocuments,
                    message: i19n.to.movetheselecteddocumentsinto
                },
                dialogoptions: {
                    ok: {
                        label: i19n.to.okay,
                        message: i19n.to.documentscopiedtodocumentclipboardnavigatetomove
                    },
                    cancel: {
                        label: i19n.to.cancel,
                        message: i19n.to.removethedocumentsfromthedocumentclipboardandclose
                    }
                }
            };

            __extends(_Action, _super);

            function _Action(context, disableFilters, hideFilters) {
                _super.call(this, _i19n.action, "fa-cut", context, disableFilters, hideFilters);

                this.command = Action.getCommand(this, { execute: execute });
            }

            function execute(action, complete) {
                var documents = action.context.checkedDocuments();

                documentsService.actions.canMoveDocuments(documents)
                .done(function (result) {
                    var promise;

                    if (!result.success) {
                        promise = dialogService.showDialog("modals/secured/explorer/details/tabs/actions/DocumentActionErrorModal", [result]);
                    } else {
                        promise = dialogService.showMessageBox(
                            String.format(i19n.to._documentscopiedtothedocument, documents.length),
                            i19n.to.usethefoldermenutomove,
                            _.toArray(_i19n.dialogoptions)
                        );

                        promise.then(function (dialogResult) {
                            if (dialogResult == _i19n.dialogoptions.ok) {
                                ctx.pfolder = ctx.current.folder;
                                
                                documentClipboard.cut(documents);
                            } else {
                                ctx.pfolder = null;

                                documentClipboard.clear();
                            }
                        });
                    }

                    promise.always(complete);
                });
            }
 
            return _Action;

        })(Action);

        return MoveDocumentsAction;
        
    });
